import { lazy } from 'react'

const FlowControl = {
  FlowRecord: lazy(() => import('./FlowRecord')),
  ControlLog: lazy(() => import('./ControlLog'))
}

export default FlowControl